import { useCallback, useContext, useMemo } from "react";

import { AnalyticsContext, GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { IMPRESSION_ACTIONS } from "@payment-client/analytics/constants";
import { CLICK_ACTIONS } from "@payment-client/analytics/constants";
import { MARKETPLACE_BUSINESS_LINE } from "@swiggy-private/payment-types";
import { CodSpecificActions } from "@swiggy-private/payment-ui";

const useCodHandler = (screenName: string) => {
    const { impressionEvent, clickEvent } = useContext(AnalyticsContext);

    const businessLine = useMemo(
        () =>
            GlobalHeaderState.getHeader(SwgyHeaderKeysList.marketplaceBusinessLine) ||
            MARKETPLACE_BUSINESS_LINE.REGULAR,
        [],
    );

    const onLoadCodHalfCard = useCallback(
        (flow: string) => {
            impressionEvent({
                category: screenName,
                action: IMPRESSION_ACTIONS.IMPRESSION_CASH_ORDER,
                context: JSON.stringify({ flow, businessLine }),
            });
        },
        [screenName, businessLine, impressionEvent],
    );

    const onPlaceCodHalfCardCTa = useCallback(
        (flow: string, isSliderCompleted?: "yes" | "no") => {
            clickEvent({
                category: screenName,
                action: CLICK_ACTIONS.CLICK_CASH_ORDER_PLACE,
                context: JSON.stringify({
                    flow,
                    businessLine,
                    ...(isSliderCompleted && { slider: isSliderCompleted }),
                }),
            });
        },
        [screenName, businessLine, clickEvent],
    );

    const onCancelHalfCard = useCallback(
        (flow: string) => {
            clickEvent({
                category: screenName,
                action: CLICK_ACTIONS.CLICK_CASH_ORDER_CANCEL,
                context: JSON.stringify({ flow, businessLine }),
            });
        },
        [screenName, businessLine, clickEvent],
    );

    const codSpecificActions = useMemo(
        (): CodSpecificActions => ({
            onLoadCodHalfCard,
            onPlaceCodHalfCardCTa,
            onCancelHalfCard,
        }),
        [onLoadCodHalfCard, onPlaceCodHalfCardCTa, onCancelHalfCard],
    );

    return {
        codSpecificActions,
    };
};

export default useCodHandler;
